export default {
  EDIT_ADDRESS: Symbol('EDIT_ADDRESS'),
  DELETE_ADDRESS: Symbol('DELETE_ADDRESS'),
};
